import SuccessImage from '@icons/success.svg'
import { GlobalContext, tr } from 'mmfintech-commons'
import { Button } from 'mmfintech-portal-commons'
import { useContext } from 'react'

import './ApplicationFeeSuccessModal.scss'

function ApplicationFeeSuccessModal() {
  const { modalHide } = useContext(GlobalContext)

  return (
    <div className='success-container' data-test='application-fee-paid-success'>
      <img src={SuccessImage} alt='' />

      <div className='success-subtitle'>
        {tr('FRONTEND.PAYMENT.SUCCESS', 'Your Application Fee has been paid successfully')}
      </div>

      <Button
        type='button'
        color='primary'
        text={tr('FRONTEND.BUTTONS.OK', 'Ok')}
        onClick={modalHide}
        data-test='button-ok'
      />
    </div>
  )
}

export default ApplicationFeeSuccessModal
